import { ReactElement } from 'react';
import { NextPageContext } from 'next';
import Head from 'next/head';
import { generateCookieList } from 'common/utils/trackingTag';
import CoursePageSection from 'components/CoursePageSection';
import { SITE_BASE_URL } from 'config/env';
import { parse } from 'cookie';

export default function CoursesPage({
  children,
}: {
  children: ReactElement;
}): JSX.Element {
  return (
    <>
      <Head>
        <title>教育コース | PostPrime</title>
        <meta
          name="description"
          content="様々な経歴をもつ講師が多様なトピックでノウハウを伝授！"
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="全てのコースをみてみよう | PostPrime"
        />
        <meta
          property="og:description"
          content="様々な経歴をもつ講師が多様なトピックでノウハウを伝授！"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={`${SITE_BASE_URL}/courses`} />
        <meta
          name="twitter:title"
          content="全てのコースをみてみよう | PostPrime"
        />
        <meta
          name="twitter:description"
          content="様々な経歴をもつ講師が多様なトピックでノウハウを伝授！"
        />
        <link rel="canonical" href={`${SITE_BASE_URL}/courses`} />
      </Head>
      <CoursePageSection>{children}</CoursePageSection>
    </>
  );
}

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }

  return {
    props: {},
  };
};
